import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import consentDeclineAlertIcon from '../assets/consent-decline-alert.svg'
import { CONSENT_DECLINE_MESSAGE } from '../lib/constants'
import {
  consentDeclinedMessageSx,
  consentDeclinedPanelSx,
  consentRetryButtonSx,
} from '../styles/instrumentOnboardingStyles'
import { signupShareOutlinedButtonSx, useSignupShareTheme } from '../styles/signupShareTheme'

interface ConsentDeclinedPanelProps {
  readonly onRetry: () => void
}

/** Figma 4950:6971 / icon 4950:7002 — hard stop after Decline (TC-SPW-20 / TC-SPW-26). */
/** Footer slot content only — parent `ConsentPolicyCard` supplies the bordered footer. */
export function ConsentDeclinedPanel({ onRetry }: ConsentDeclinedPanelProps) {
  const signupTheme = useSignupShareTheme()
  return (
    <Box sx={consentDeclinedPanelSx} data-testid="instrument-onboarding-consent-declined">
      <Box
        component="img"
        src={consentDeclineAlertIcon}
        alt=""
        aria-hidden
        sx={{ width: 64, height: 64, display: 'block', flexShrink: 0 }}
        data-testid="instrument-onboarding-consent-decline-icon"
      />
      <Typography
        component="p"
        role="alert"
        sx={consentDeclinedMessageSx}
        data-testid="instrument-onboarding-consent-decline-message"
      >
        {CONSENT_DECLINE_MESSAGE}
      </Typography>
      <Button
        type="button"
        variant="outlined"
        fullWidth
        onClick={onRetry}
        data-testid="instrument-onboarding-consent-retry"
        sx={[consentRetryButtonSx, signupTheme ? signupShareOutlinedButtonSx : null]}
      >
        Retry Consent
      </Button>
    </Box>
  )
}
